import { PropsWithChildren } from "react";

import { Typography } from "@aircall/tractor";

export function TranscriptionSubTitle({
  children,
  "data-test": dataTest = "transcription-message-subtitle",
}: PropsWithChildren<{
  "data-test"?: string;
}>) {
  return (
    <Typography variant="bodyRegularM" textAlign="center" data-test={dataTest}>
      {children}
    </Typography>
  );
}
